import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import {config} from'../config/config';

interface Props {
    rank?: number;
}

interface State {
    open: boolean;
}

function Message1(props){
    return <ModalBody >
        {props.rank===0 && <h2>Vous avez 2 retours possibles</h2>}
        {props.rank===1 && <h2>Dernier retour !</h2>}
        <strong>Chaque retour comporte {config.maxCommentCount} punaises modificatives</strong>
        <img src={'assets/retour-'+props.rank+'.jpg'}/>
        <h1>Vous êtes au retour {props.rank+1}/2</h1>
        <p>Avez-vous consulté vos collègues concernés par cette prestation et recueillis leurs demandes ? <br/>
            Avez-vous vraiment regroupé toutes les modifications ?<br/>
        Si vous avez beaucoup de retour, faites le point sur la pertinance de chaque demande ?
        </p>
    </ModalBody>
}

function Message2(props){
    return <ModalBody >
        <h2>Dernière étape</h2>
        <strong>Vous pourrez ensuite télécharger votre prestation</strong>
        <img src={'assets/retour-2.jpg'}/>
        <h1>Validez</h1>
        <p>Si vous avez de nouveaux retours,<br/>
            appliquez vos punaises, un devis modificatif sera effectué.
        </p>
    </ModalBody>
}


class AlertProposalRankModal extends React.Component<Props> {
    state: State = {
        open: true
    }
    close=()=>{
        this.setState({
            open: false
        })
    }
    render() {

        return (
            <Modal
                isOpen={this.state.open}
                toggle={this.close}
                modalClassName='alert-rank-modal'
                backdrop="static"
            >
                {this.props.rank!== undefined && this.props.rank < 2 ?
                    <Message1 rank={this.props.rank}/> :
                    <Message2/>
                }
                <ModalFooter>
                    <Button color="secondary" onClick={this.close}>{this.props.rank && this.props.rank<2?'Modifier':'Valider ou demander de nouvelles modifications'}</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AlertProposalRankModal;



// WEBPACK FOOTER //
// ./src/components/AlertProposalRankModal.tsx